import { useEffect } from "react"; 
import { useAuth } from "./authContext";

/**
 * 🛠️ Custom Hook: `useAuthListener`
 * Legacy helper retained for compatibility. It simply triggers a user refresh using
 * the provider's existing listener instead of registering a second subscription.
 */
export const useAuthListener = () => {
  const { refreshUser } = useAuth();

  useEffect(() => {
    const run = async () => {
      if (typeof refreshUser !== "function") return;
      await refreshUser();
    };
    run();
  }, [refreshUser]);
};
